export default __webpack_public_path__ + "static/media/UPDATE_STATUS_BUTTON.336c278e.svg";